import { eventsApi, tools as _ } from '../object-plus/index.js';
import { CompiledReference } from '../traversable.js';
import { ChainableAttributeSpec } from './attrDef.js';
import { AnyType } from './metatypes/index.js';
import { constructorsMixin } from './updates.js';
export function createAttribute(spec, name) {
    return AnyType.create(ChainableAttributeSpec.from(spec).options, name);
}
export function createAttributesMixin(attributesDefinition, baseClassAttributes) {
    const myAttributes = _.transform({}, attributesDefinition, createAttribute), allAttributes = _.defaults({}, myAttributes, baseClassAttributes);
    const ConstructorsMixin = constructorsMixin(allAttributes);
    return Object.assign(Object.assign(Object.assign(Object.assign({}, ConstructorsMixin), { _attributes: new ConstructorsMixin.AttributesCopy(allAttributes), _attributesArray: Object.keys(allAttributes).map(key => allAttributes[key]), properties: _.transform({}, myAttributes, x => x.createPropertyDescriptor()) }), localEventsMixin(myAttributes)), { _endpoints: _.transform({}, allAttributes, attrDef => attrDef.options.endpoint) });
}
function localEventsMixin(attrSpecs) {
    let _localEvents;
    for (var key in attrSpecs) {
        const attribute = attrSpecs[key], { _onChange } = attribute.options;
        if (_onChange) {
            _localEvents || (_localEvents = new eventsApi.EventMap());
            _localEvents.addEvent('change:' + key, typeof _onChange === 'string' ?
                createWatcherFromRef(_onChange, key) :
                wrapWatcher(_onChange, key));
        }
    }
    return _localEvents ? { _localEvents } : {};
}
function wrapWatcher(watcher, key) {
    return function (record, value) {
        watcher.call(record, value, key);
    };
}
function createWatcherFromRef(ref, key) {
    const { local, resolve, tail } = new CompiledReference(ref, true);
    return local ?
        function (record, value) {
            record[tail](value, key);
        } :
        function (record, value) {
            resolve(record)[tail](value, key);
        };
}
//# sourceMappingURL=mixin.js.map